module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAPCAYAAADphp8SAAAAAXNSR0IArs4c6QAAAQNJREFUOBGdkkFqwkAYhTOCuyoU7KLoRheFHqAnKARqN3qJupKeoKv2Fl3nChUsPYGIbt2J2wZbWlHExfR70ECaSWqSBx/z5/3zP4bJGGvtjed5D3AGZRQy9GgIWlBclEmIzSwrfHzGjLLlyuNEPuyhrDTrK6gGXVhDUX0wcAsnCppDB5owhrx6ZWML2jBTkLSBAejyh7CFLO1o3EMF7uAbbBSkWhrBOVzCFJKSp572vMSbySD1QuhDFZ5AJxCq5fXgHf4oLSja8ExxCvoZQrW8VOlO7D+P54ve22//mrWetfdYUNac4+tlHxy3uHFQUFB8zpkIjCyu6Yql4bTzGaExZvIDy535ELe5SDcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/ic-email.png
// module id = 1403
// module chunks = 0